module.exports = "/_next/static/images/invitation-sent-f3f7ec805ed9bf41259d4dda22b26ef2.svg";